// Physical Science Questions for AFOQT
// Physics, chemistry, and general science

export const physicalScienceData = [
  {
    id: 1,
    text: "What is the chemical symbol for water?",
    options: ["H₂O", "O₂", "CO₂", "H₂"],
    correct: 0,
    explanation: "Water is composed of two hydrogen atoms and one oxygen atom: H2O."
  },
  {
    id: 2,
    text: "Which of the following is NOT a state of matter?",
    options: ["Solid", "Liquid", "Gas", "Energy"],
    correct: 3,
    explanation: "Energy is not a state of matter. The common states are solid, liquid, and gas."
  },
  {
    id: 3,
    text: "At what temperature does water boil at sea level?",
    options: ["50°C", "75°C", "100°C", "125°C"],
    correct: 2,
    explanation: "Water boils at 100°C (212°F) at standard atmospheric pressure at sea level."
  },
   {
    id: 4,
    text: "What force keeps planets in orbit around the Sun?",
    options: ["Magnetic force", "Electrostatic force", "Gravitational force", "Nuclear force"],
    correct: 2,
    explanation: "The gravitational pull of the Sun keeps the planets in orbit."
  },
  {
    id: 5,
    text: "Which subatomic particle has a negative charge?",
    options: ["Proton", "Electron", "Neutron", "Photon"],
    correct: 1,
    explanation: "Electrons carry a negative electric charge."
  },
  {
    id: 6,
    text: "What is the most abundant gas in Earth's atmosphere?",
    options: ["Oxygen", "Carbon dioxide", "Nitrogen", "Hydrogen"],
    correct: 2,
    explanation: "Nitrogen makes up about 78% of Earth's atmosphere."
  },
  {
    id: 7,
    text: "What is the process by which plants make their own food?",
    options: ["Respiration", "Photosynthesis", "Fermentation", "Transpiration"],
    correct: 1,
    explanation: "Photosynthesis uses sunlight, carbon dioxide, and water to make glucose and oxygen."
  },
  {
    id: 8,
    text: "Which of the following is an example of a chemical change?",
    options: ["Melting ice", "Boiling water", "Rusting iron", "Breaking glass"],
    correct: 2,
    explanation: "Rusting is a chemical reaction between iron and oxygen, forming iron oxide."
  },
  {
    id: 9,
    text: "What is the unit of electrical resistance?",
    options: ["Ampere", "Volt", "Ohm", "Watt"],
    correct: 2,
    explanation: "Electrical resistance is measured in ohms (Ω)."
  },
  {
    id: 10,
    text: "What type of energy is stored in a stretched rubber band?",
    options: ["Kinetic energy", "Thermal energy", "Potential energy", "Nuclear energy"],
    correct: 2,
    explanation: "A stretched rubber band stores elastic potential energy."
  },
  {
    id: 11,
    text: "What planet is known as the Red Planet?",
    options: ["Venus", "Mars", "Jupiter", "Mercury"],
    correct: 1,
    explanation: "Mars appears red due to iron oxide (rust) on its surface."
  },
  {
    id: 12,
    text: "Which particle in the atom determines its atomic number?",
    options: ["Neutron", "Electron", "Proton", "Photon"],
    correct: 2,
    explanation: "The number of protons in the nucleus defines the atomic number."
  },
  {
    id: 13,
    text: "What kind of bond involves the sharing of electrons between atoms?",
    options: ["Ionic bond", "Covalent bond", "Metallic bond", "Hydrogen bond"],
    correct: 1,
    explanation: "In covalent bonds, atoms share electrons to achieve stability."
  },
  {
    id: 14,
    text: "Which law states that for every action there is an equal and opposite reaction?",
    options: ["Newton’s First Law", "Newton’s Second Law", "Newton’s Third Law", "Law of Conservation of Energy"],
    correct: 2,
    explanation: "Newton’s Third Law of Motion describes how forces act in pairs."
  },
  {
    id: 15,
    text: "What is the pH of pure water at room temperature?",
    options: ["3", "5", "7", "9"],
    correct: 2,
    explanation: "Pure water is neutral with a pH of 7."
  },
  {
    id: 16,
    text: "What phenomenon causes a straw to look bent in a glass of water?",
    options: ["Reflection", "Refraction", "Diffraction", "Dispersion"],
    correct: 1,
    explanation: "Light bends as it passes from air to water due to refraction."
  },
  {
    id: 17,
    text: "What form of heat transfer occurs through direct contact?",
    options: ["Conduction", "Convection", "Radiation", "Diffusion"],
    correct: 0,
    explanation: "Conduction transfers heat through direct contact between materials."
  },
  {
    id: 18,
    text: "Which of the following is a renewable energy source?",
    options: ["Coal", "Natural gas", "Solar", "Oil"],
    correct: 2,
    explanation: "Solar energy is renewable because it comes from the Sun, which is continuously available."
  },
  {
    id: 19,
    text: "Which element is necessary for combustion to occur?",
    options: ["Nitrogen", "Oxygen", "Carbon", "Hydrogen"],
    correct: 1,
    explanation: "Oxygen supports combustion by reacting with fuel."
  },
  {
    id: 20,
    text: "What type of celestial body is the Sun?",
    options: ["Planet", "Star", "Asteroid", "Comet"],
    correct: 1,
    explanation: "The Sun is a medium-sized star composed primarily of hydrogen and helium."
  },
  {
    id: 21,
    text: "What is the smallest unit of matter that retains chemical properties?",
    options: ["Atom", "Molecule", "Electron", "Proton"],
    correct: 0,
    explanation: "The atom is the basic unit of matter that defines chemical elements."
  },
  {
    id: 22,
    text: "Which planet has the strongest gravity in our solar system?",
    options: ["Earth", "Saturn", "Jupiter", "Neptune"],
    correct: 2,
    explanation: "Jupiter’s large mass gives it the strongest gravitational pull among the planets."
  },
  {
    id: 23,
    text: "What kind of energy transformation occurs when a flashlight is turned on?",
    options: ["Chemical to electrical to light", "Thermal to mechanical to chemical", "Nuclear to heat to kinetic", "Potential to kinetic to light"],
    correct: 0,
    explanation: "Battery chemicals produce electricity, which powers the bulb to emit light."
  },
  {
    id: 24,
    text: "What is the main component of natural gas?",
    options: ["Propane", "Methane", "Butane", "Ethane"],
    correct: 1,
    explanation: "Methane (CH₄) makes up the majority of natural gas."
  },
  {
    id: 25,
    text: "Which type of rock forms from cooled molten lava or magma?",
    options: ["Sedimentary", "Metamorphic", "Igneous", "Obsidian"],
    correct: 2,
    explanation: "Igneous rocks form when magma or lava cools and solidifies."
  },
   {
    id: 26,
    text: "What is the acceleration due to gravity on Earth’s surface?",
    options: ["9.8 m/s²", "10.5 m/s²", "8.9 m/s²", "12.1 m/s²"],
    correct: 0,
    explanation: "The average acceleration due to gravity on Earth’s surface is 9.8 meters per second squared."
  },
  {
    id: 27,
    text: "What is the basic unit of electric current?",
    options: ["Volt", "Ampere", "Ohm", "Watt"],
    correct: 1,
    explanation: "Electric current is measured in amperes (A)."
  },
  {
    id: 28,
    text: "What is the most common element in the universe?",
    options: ["Oxygen", "Hydrogen", "Helium", "Carbon"],
    correct: 1,
    explanation: "Hydrogen makes up about 75% of the elemental mass of the universe."
  },
  {
    id: 29,
    text: "Which layer of Earth's atmosphere contains the ozone layer?",
    options: ["Stratosphere", "Troposphere", "Mesosphere", "Thermosphere"],
    correct: 0,
    explanation: "The ozone layer, which absorbs harmful UV radiation, is located in the stratosphere."
  },
  {
    id: 30,
    text: "What type of energy is associated with moving objects?",
    options: ["Thermal energy", "Kinetic energy", "Potential energy", "Chemical energy"],
    correct: 1,
    explanation: "Kinetic energy is the energy of motion."
  },
  {
    id: 31,
    text: "What is the atomic number of carbon?",
    options: ["5", "6", "7", "8"],
    correct: 1,
    explanation: "Carbon has 6 protons, giving it an atomic number of 6."
  },
  {
    id: 32,
    text: "What phenomenon causes echoes to occur?",
    options: ["Reflection of light", "Refraction of light", "Reflection of sound", "Diffraction of sound"],
    correct: 2,
    explanation: "An echo is caused by the reflection of sound waves from a surface."
  },
  {
    id: 33,
    text: "Which type of electromagnetic wave has the shortest wavelength?",
    options: ["X-rays", "Gamma rays", "Ultraviolet", "Microwaves"],
    correct: 1,
    explanation: "Gamma rays have the shortest wavelength and highest energy in the electromagnetic spectrum."
  },
  {
    id: 34,
    text: "What is the process of converting a liquid into a gas called?",
    options: ["Condensation", "Evaporation", "Sublimation", "Deposition"],
    correct: 1,
    explanation: "Evaporation is the process where a liquid changes into a gas at its surface."
  },
  {
    id: 35,
    text: "Which law of motion states that an object will remain at rest or in uniform motion unless acted on by a force?",
    options: ["Newton’s First Law of Motion", "Newton’s Second Law of Motion", "Newton’s Third Law of Motion", "Law of Universal Gravitation"],
    correct: 0,
    explanation: "Newton’s First Law describes inertia — the tendency of objects to resist changes in motion."
  },
  {
    id: 36,
    text: "What kind of rock is formed from layers of sediment compacted over time?",
    options: ["Metamorphic", "Igneous", "Sedimentary", "Volcanic"],
    correct: 2,
    explanation: "Sedimentary rocks form from the accumulation and compaction of sediments."
  },
  {
    id: 37,
    text: "Which particle has the smallest mass?",
    options: ["Neutron", "Proton", "Electron", "Alpha particle"],
    correct: 2,
    explanation: "The electron is much lighter than protons or neutrons."
  },
  {
    id: 38,
    text: "What is the main gas responsible for the greenhouse effect?",
    options: ["Oxygen", "Carbon dioxide", "Nitrogen", "Hydrogen"],
    correct: 1,
    explanation: "Carbon dioxide traps heat in the atmosphere, contributing to the greenhouse effect."
  },
  {
    id: 39,
    text: "What is the SI unit of force?",
    options: ["Watt", "Joule", "Newton", "Pascal"],
    correct: 2,
    explanation: "Force is measured in newtons (N), where 1 N = 1 kg·m/s²."
  },
  {
    id: 40,
    text: "Which scientist developed the periodic table?",
    options: ["Isaac Newton", "Dmitri Mendeleev", "Albert Einstein", "Marie Curie"],
    correct: 1,
    explanation: "Dmitri Mendeleev organized the elements by atomic weight, forming the first periodic table."
  },
  {
    id: 41,
    text: "What is the main energy source driving the water cycle?",
    options: ["Wind", "Geothermal heat", "Solar energy", "Tidal forces"],
    correct: 2,
    explanation: "Solar energy causes evaporation, driving the entire water cycle."
  },
  {
    id: 42,
    text: "What is the term for materials that do not conduct electricity well?",
    options: ["Conductors", "Resistors", "Insulators", "Transistors"],
    correct: 2,
    explanation: "Insulators, like rubber and glass, resist the flow of electric current."
  },
  {
    id: 43,
    text: "What property of a sound wave determines its pitch?",
    options: ["Frequency", "Amplitude", "Wavelength", "Speed"],
    correct: 0,
    explanation: "The frequency of a sound wave determines how high or low its pitch is."
  },
  {
    id: 44,
    text: "What type of bond forms between a metal and a nonmetal?",
    options: ["Covalent bond", "Ionic bond", "Hydrogen bond", "Metallic bond"],
    correct: 1,
    explanation: "Ionic bonds form when electrons are transferred from metals to nonmetals."
  },
  {
    id: 45,
    text: "What is the hardest natural substance on Earth?",
    options: ["Steel", "Graphite", "Quartz", "Diamond"],
    correct: 3,
    explanation: "Diamond, a form of carbon, is the hardest naturally occurring material."
  },
  {
    id: 46,
    text: "What is the main cause of Earth's magnetic field?",
    options: ["Solar radiation", "Plate tectonics", "Planetary Core Spin", "Atmospheric circulation"],
    correct: 1,
    explanation: "The movement of molten iron in Earth’s outer core generates its magnetic field."
  },
  {
    id: 47,
    text: "What type of energy is stored in chemical bonds?",
    options: ["Thermal energy", "Chemical potential energy", "Kinetic energy", "Nuclear energy"],
    correct: 1,
    explanation: "Chemical potential energy is stored in the bonds between atoms and molecules."
  },
  {
    id: 48,
    text: "Which planet has a day longer than its year?",
    options: ["Mercury", "Venus", "Mars", "Neptune"],
    correct: 1,
    explanation: "Venus rotates very slowly; one rotation takes longer than one revolution around the Sun."
  },
  {
    id: 49,
    text: "What type of front forms when a warm air mass meets a cold air mass and rises over it?",
    options: ["Cold front", "Warm front", "Occluded front", "Stationary front"],
    correct: 1,
    explanation: "A warm front occurs when warm air rises gradually over retreating cold air."
  },
  {
    id: 50,
    text: "Which law states that energy cannot be created or destroyed, only transformed?",
    options: ["Law of Conservation of Mass", "Law of Conservation of Energy", "Law of Conservation of Atomic Mass", "Law of Conservation of Momentum"],
    correct: 1,
    explanation: "The Law of Conservation of Energy states that energy can only change form, not be created or destroyed."
  },
  {
    id: 51,
    text: "Which subatomic particle determines the atomic number of an element?",
    options: ["Neutron", "Proton", "Electron", "Quark"],
    correct: 1,
    explanation: "The number of protons in an atom defines its atomic number and identity."
  },
  {
    id: 52,
    text: "What type of simple machine is a seesaw?",
    options: ["Pulley", "Inclined plane", "Lever", "Wheel and axle"],
    correct: 2,
    explanation: "A seesaw is a lever — a rigid bar pivoting around a fulcrum."
  },
  {
    id: 53,
    text: "Which gas makes up least of Earth's atmosphere?",
    options: ["Oxygen", "Carbon dioxide", "Nitrogen", "Argon"],
    correct: 3,
    explanation: "Nitrogen makes up about 78% of Earth's atmosphere."
  },
  {
    id: 54,
    text: "What kind of reaction releases energy in the form of heat or light?",
    options: ["Endothermic", "Exothermic", "Neutralization", "Catalytic"],
    correct: 1,
    explanation: "Exothermic reactions release energy, while endothermic reactions absorb it."
  },
  {
    id: 55,
    text: "What type of energy transformation occurs when you use a flashlight?",
    options: ["Chemical → Light", "Electrical → Sound", "Thermal → Light", "Kinetic → Light"],
    correct: 0,
    explanation: "The battery’s chemical energy converts to light energy when the flashlight is turned on."
  },
  {
    id: 56,
    text: "Which scale is most commonly used to measure earthquake magnitude?",
    options: ["Beaufort scale", "Richter scale", "Fahrenheit scale", "Mercalli scale"],
    correct: 1,
    explanation: "The Richter scale measures the magnitude (energy) released by an earthquake."
  },
  {
    id: 57,
    text: "What is the pH of pure water at 25°C?",
    options: ["5", "6", "7", "8"],
    correct: 2,
    explanation: "Pure water is neutral with a pH of 7 at standard temperature."
  },
  {
    id: 58,
    text: "What type of circuit allows electricity to flow along only one path?",
    options: ["Parallel circuit", "Series circuit", "Closed circuit", "Open circuit"],
    correct: 1,
    explanation: "A series circuit provides a single path for current to flow through all components."
  },
  {
    id: 59,
    text: "Which planet has the largest number of moons?",
    options: ["Earth", "Mars", "Jupiter", "Saturn"],
    correct: 3,
    explanation: "Saturn currently has the most known moons of any planet in the solar system."
  },
  {
    id: 60,
    text: "What is the process called when a solid changes directly into a gas?",
    options: ["Evaporation", "Condensation", "Sublimation", "Deposition"],
    correct: 2,
    explanation: "Sublimation occurs when a solid transitions directly into a gas, as with dry ice."
  },
  {
    id: 61,
    text: "What is the smallest unit of a chemical element that retains its properties?",
    options: ["Molecule", "Compound", "Atom", "Ion"],
    correct: 2,
    explanation: "An atom is the smallest particle of an element that retains its identity in a reaction."
  },
  {
    id: 62,
    text: "What is the main cause of tides on Earth?",
    options: ["Earth’s rotation", "Solar radiation", "Wind patterns", "Moon’s gravitational pull"],
    correct: 3,
    explanation: "Tides result primarily from the gravitational attraction between the Moon and Earth."
  },
  {
    id: 63,
    text: "Which color of light has the highest frequency?",
    options: ["Red", "Green", "Blue", "Violet"],
    correct: 3,
    explanation: "Violet light has the shortest wavelength and highest frequency in the visible spectrum."
  },
  {
    id: 64,
    text: "What is formed when two or more elements chemically combine in fixed ratios?",
    options: ["Mixture", "Solution", "Compound", "Suspension"],
    correct: 2,
    explanation: "A compound is a pure substance formed by chemically bonding elements in fixed ratios."
  },
  {
    id: 65,
    text: "Which layer of the Earth is liquid and responsible for generating the magnetic field?",
    options: ["Crust", "Mantle", "Outer core", "Inner core"],
    correct: 2,
    explanation: "The outer core is molten iron and nickel that moves to produce Earth’s magnetic field."
  },
  {
    id: 66,
    text: "What is the primary gas produced during photosynthesis?",
    options: ["Oxygen", "Carbon dioxide", "Nitrogen", "Methane"],
    correct: 0,
    explanation: "Plants produce oxygen as a byproduct of photosynthesis."
  },
  {
    id: 67,
    text: "Which scientist proposed the three laws of motion?",
    options: ["Galileo Galilei", "Albert Einstein", "Isaac Newton", "James Clerk Maxwell"],
    correct: 2,
    explanation: "Sir Isaac Newton formulated the three fundamental laws of motion."
  },
  {
    id: 68,
    text: "What type of energy is released in a nuclear fission reaction?",
    options: ["Thermal and light energy", "Sound energy", "Mechanical energy", "Nuclear energy"],
    correct: 0,
    explanation: "Nuclear fission releases large amounts of heat and light energy."
  },
  {
    id: 69,
    text: "What is the measure of the average kinetic energy of particles in a substance?",
    options: ["Pressure", "Density", "Temperature", "Volume"],
    correct: 2,
    explanation: "Temperature reflects the average kinetic energy of the particles in a material."
  },
  {
    id: 70,
    text: "Which part of an atom has a negative charge?",
    options: ["Proton", "Neutron", "Electron", "Nucleus"],
    correct: 2,
    explanation: "Electrons carry a negative charge and orbit the atomic nucleus."
  },
  {
    id: 71,
    text: "What term describes the bending of light when it passes through different materials?",
    options: ["Refraction", "Reflection", "Diffraction", "Interference"],
    correct: 0,
    explanation: "Refraction is the bending of light as it moves between materials with different densities."
  },
  {
    id: 72,
    text: "What is the name of the boundary where two tectonic plates collide?",
    options: ["Transform boundary", "Divergent boundary", "Convergent boundary", "Subduction zone"],
    correct: 2,
    explanation: "A convergent boundary occurs where plates move toward one another and may form mountains."
  },
  {
    id: 73,
    text: "Which element is essential for combustion to occur?",
    options: ["Hydrogen", "Nitrogen", "Carbon", "Oxygen"],
    correct: 3,
    explanation: "Oxygen is required for combustion reactions to take place."
  },
  {
    id: 74,
    text: "What type of rock is formed by cooling and solidification of molten magma?",
    options: ["Metamorphic", "Igneous", "Sedimentary", "Basaltic"],
    correct: 1,
    explanation: "Igneous rocks form when molten rock (magma or lava) cools and hardens."
  },
  {
    id: 75,
    text: "What is the most abundant element in Earth’s crust?",
    options: ["Iron", "Oxygen", "Silicon", "Aluminum"],
    correct: 1,
    explanation: "Oxygen makes up nearly half of Earth’s crust by weight, primarily in oxides and silicates."
  },
  {
    id: 76,
    text: "What is the SI unit of electric charge?",
    options: ["Volt", "Ampere", "Coulomb", "Ohm"],
    correct: 2,
    explanation: "The coulomb is the standard unit of electric charge in the International System of Units."
  },
  {
    id: 77,
    text: "Which branch of physics deals with the motion of objects without considering its causes?",
    options: ["Kinetics", "Dynamics", "Kinematics", "Statics"],
    correct: 2,
    explanation: "Kinematics focuses on describing motion without analyzing the forces that cause it."
  },
  {
    id: 78,
    text: "What remains constant for an object in projectile motion wilie neglecting air resistance and not in a vacuum?",
    options: ["Vertical velocity", "Horizontal velocity", "Acceleration", "Speed"],
    correct: 1,
    explanation: "Horizontal velocity remains constant because no horizontal forces act on the projectile."
  },
  {
    id: 79,
    text: "What is the acceleration due to gravity on Earth?",
    options: ["8.9 m/s²", "9.8 m/s²", "10.5 m/s²", "9.2 m/s²"],
    correct: 1,
    explanation: "The acceleration due to gravity near Earth's surface averages 9.8 meters per second squared."
  },
  {
    id: 80,
    text: "Who formulated the three laws of motion?",
    options: ["Galileo Galilei", "Isaac Newton", "Albert Einstein", "Niels Bohr"],
    correct: 1,
    explanation: "Sir Isaac Newton described the fundamental laws of motion in his work *Principia Mathematica*."
  },
  {
    id: 81,
    text: "Which form of energy is stored in a stretched bow?",
    options: ["Chemical potential", "Kinetic potential", "Elastic potential", "Thermal potential"],
    correct: 2,
    explanation: "Elastic potential energy is stored when materials are stretched or compressed."
  },
  {
    id: 82,
    text: "What is the unit of measurement for energy?",
    options: ["Newton", "Joule", "Watt", "Pascal"],
    correct: 1,
    explanation: "Energy is measured in joules, equivalent to one newton-meter."
  },
  {
    id: 83,
    text: "Why do stars appear to twinkle in the night sky?",
    options: ["Scattering", "Refraction", "Reflection", "Diffraction"],
    correct: 1,
    explanation: "Refraction of starlight through turbulent air layers causes the apparent twinkling effect."
  },
  {
    id: 84,
    text: "Which subatomic particle carries a positive charge?",
    options: ["Proton", "Electron", "Neutron", "Positron"],
    correct: 0,
    explanation: "Electrons are negatively charged particles orbiting the nucleus of an atom."
  },
  {
    id: 85,
    text: "Which law relates voltage, current, and resistance?",
    options: ["Faraday’s Law", "Coulomb’s Law", "Ohm’s Law", "Ampere’s Law"],
    correct: 2,
    explanation: "Ohm’s Law states V = IR, where voltage equals current times resistance."
  },
  {
    id: 86,
    text: "What is the primary purpose of a transformer?",
    options: ["Increase current", "Change voltage", "Generate electricity", "Store energy"],
    correct: 1,
    explanation: "A transformer changes voltage levels through electromagnetic induction."
  },
  {
    id: 87,
    text: "Which type of lens is used to correct nearsightedness?",
    options: ["Convex", "Cylindrical", "Plano-convex", "Concave"],
    correct: 3,
    explanation: "A concave lens diverges light rays, helping nearsighted individuals see distant objects clearly."
  },
  {
    id: 88,
    text: "Which type of wave requires a medium to travel through?",
    options: ["Light", "Radio", "Sound", "X-ray"],
    correct: 2,
    explanation: "Sound waves are mechanical and need a medium such as air, water, or solids to propagate."
  },
  {
    id: 89,
    text: "What is the formula for kinetic energy?",
    options: ["m × v²", "½ m v²", "m × a", "m × g × h"],
    correct: 1,
    explanation: "Kinetic energy is calculated as ½ × mass × velocity squared."
  },
  {
    id: 90,
    text: "Which type of electromagnetic radiation has the highest energy?",
    options: ["Ultraviolet", "X-rays", "Gamma rays", "Microwaves"],
    correct: 2,
    explanation: "Gamma rays have the shortest wavelength and highest frequency, giving them the most energy."
  },
  {
    id: 91,
    text: "What is the approximate speed of light in a vacuum?",
    options: ["150,000 km/s", "200,000 km/s", "300,000 km/s", "400,000 km/s"],
    correct: 2,
    explanation: "Light travels at about 300,000 kilometers per second (3 × 10⁸ m/s)."
  },
  {
    id: 92,
    text: "What is the purpose of control rods in a nuclear reactor?",
    options: ["Speed up reaction", "Cool the reactor", "Increase pressure", "Absorb neutrons"],
    correct: 3,
    explanation: "Control rods absorb neutrons to regulate or stop the nuclear chain reaction."
  },
  {
    id: 93,
    text: "What term describes the resistance of an object to changes in its motion?",
    options: ["Momentum", "Force", "Inertia", "Mass"],
    correct: 2,
    explanation: "Inertia is an object's tendency to resist changes in its state of motion."
  },
  {
    id: 94,
    text: "Which simple machine uses a rope and wheel to lift objects?",
    options: ["Lever", "Pulley", "Inclined plane", "Wedge"],
    correct: 1,
    explanation: "A pulley changes the direction of the force applied to lift or move loads."
  },
  {
    id: 95,
    text: "What type of material resists the flow of heat and electricity?",
    options: ["Conductor", "Insulator", "Semiconductor", "Catalyst"],
    correct: 1,
    explanation: "Insulators such as rubber and glass restrict the flow of heat and electric current."
  },
  {
    id: 96,
    text: "Which process transfers heat through direct contact?",
    options: ["Radiation", "Conduction", "Convection", "Evaporation"],
    correct: 1,
    explanation: "Conduction transfers heat between objects in direct physical contact."
  },
  {
    id: 97,
    text: "Which law states that energy cannot be created or destroyed?",
    options: ["Conservation of momentum", "Thermodynamic equilibrium", "Conservation of energy", "Entropy law"],
    correct: 2,
    explanation: "The law of conservation of energy states that energy only changes form, never disappears."
  },
  {
    id: 98,
    text: "Which planet has the strongest gravitational pull in the solar system?",
    options: ["Earth", "Pluto", "Neptune", "Jupiter"],
    correct: 1,
    explanation: "Jupiter’s massive size gives it the strongest gravity among the planets."
  },
  {
    id: 99,
    text: "What type of circuit provides multiple paths for current to flow?",
    options: ["Series", "Parallel", "Closed", "Open"],
    correct: 1,
    explanation: "In a parallel circuit, current divides into multiple paths, allowing independent operation of components."
  },
  {
    id: 100,
    text: "Who developed the theory of relativity?",
    options: ["Niels Bohr", "Max Planck", "Albert Einstein", "Erwin Schrödinger"],
    correct: 2,
    explanation: "Albert Einstein proposed the special and general theories of relativity, revolutionizing physics."
  },
  {
    id: 101,
    text: "What is the least abundant gas in Earth’s atmosphere?",
    options: ["Oxygen", "Carbon Dioxide", "Nitrogen", "Argon"],
    correct: 3,
    explanation: "Nitrogen makes up about 78% of Earth’s atmosphere, making it the most abundant gas."
  },
  {
    id: 102,
    text: "What layer of the Earth is composed mainly of liquid iron and nickel?",
    options: ["Inner core", "Outer core", "Mantle", "Crust"],
    correct: 1,
    explanation: "The outer core is molten and composed primarily of iron and nickel, generating Earth's magnetic field."
  },
  {
    id: 103,
    text: "What do we call molten rock beneath Earth’s surface?",
    options: ["Lava", "Basalt", "Magma", "Granite"],
    correct: 2,
    explanation: "Molten rock beneath the Earth's surface is called magma; once it erupts, it becomes lava."
  },
  {
    id: 104,
    text: "Which scale is used to measure the magnitude of tornadoes?",
    options: ["Fujita scale", "Beaufort scale", "Richter scale", "Mercalli scale"],
    correct: 0,
    explanation: "The Richter scale measures the magnitude of seismic energy released during an earthquake."
  },
  {
    id: 105,
    text: "What type of rock forms from the cooling of magma or lava?",
    options: ["Sedimentary", "Metamorphic", "Igneous", "Basaltic"],
    correct: 2,
    explanation: "Igneous rocks form when molten material cools and solidifies, either below or above ground."
  },
  {
    id: 106,
    text: "What is the driving force behind plate tectonics?",
    options: ["Solar radiation", "Earth’s rotation", "Mantle convection", "Magnetic fields"],
    correct: 2,
    explanation: "Convection currents in the mantle move tectonic plates slowly over geological time."
  },
  {
    id: 107,
    text: "Which process describes the breaking down of rocks into smaller pieces?",
    options: ["Deposition", "Erosion", "Sedimentation", "Weathering"],
    correct: 3,
    explanation: "Weathering is the process of breaking down rocks through physical, chemical, or biological means."
  },
  {
    id: 108,
    text: "What is the main cause of ocean waves?",
    options: ["Winds", "Earth’s rotation", "Gravitational pull of the Moon", "Continental drift"],
    correct: 0,
    explanation: "Waves are primarily caused by the wind blowing across the surface of the ocean."
  },
  {
    id: 109,
    text: "Which layer of the atmosphere is furthest from the ground?",
    options: ["Troposphere", "Stratosphere", "Mesosphere", "Exosphere"],
    correct: 3,
    explanation: "The ozone layer is located in the stratosphere, where it absorbs harmful ultraviolet radiation."
  },
  {
    id: 110,
    text: "What is the process by which plants release water vapor into the air?",
    options: ["Evaporation", "Transpiration", "Condensation", "Precipitation"],
    correct: 1,
    explanation: "Transpiration is the process where water vapor exits through small pores in plant leaves."
  },
  {
    id: 111,
    text: "Which two elements make up most of Earth’s crust?",
    options: ["Oxygen and silicon", "Iron and nickel", "Carbon and hydrogen", "Calcium and aluminum"],
    correct: 0,
    explanation: "Oxygen and silicon are the two most abundant elements in the Earth's crust, forming silicate minerals."
  },
  {
    id: 112,
    text: "What is the name of the point directly above an earthquake’s focus?",
    options: ["Epicenter", "Crater", "Hypocenter", "Fault line"],
    correct: 0,
    explanation: "The epicenter is the point on Earth’s surface directly above where an earthquake originates."
  },
  {
    id: 113,
    text: "What kind of rock forms from heat and pressure to make new kinds of rocks?",
    options: ["Igneous", "Sedimentary", "Metamorphic", "Volcanic"],
    correct: 2,
    explanation: "Metamorphic rocks arise from the transformation of existing rock to new types of rock in a process called metamorphism"
  },
  {
    id: 114,
    text: "What type of boundary occurs when two tectonic plates move apart?",
    options: ["Convergent", "Divergent", "Transform", "Neutral"],
    correct: 1,
    explanation: "At divergent boundaries, tectonic plates move away from each other, creating new crust."
  },
  {
    id: 115,
    text: "Which process in the water cycle involves liquid falling from the sky?",
    options: ["Condensation", "Evaporation", "Precipitation", "Infiltration"],
    correct: 2,
    explanation: "Precipitation occurs when water molecules gain mass and release kinetic energy and fall to the ground."
  },
  {
    id: 116,
    text: "What type of volcano is broad with gentle slopes, like those in Hawaii?",
    options: ["Shield volcano", "Cinder cone", "Composite volcano", "Caldera"],
    correct: 0,
    explanation: "Shield volcanoes have wide, gentle slopes formed by fluid lava flows, typical of Hawaiian volcanoes."
  },
  {
    id: 117,
    text: "What causes the seasons on Earth?",
    options: ["Distance from the Sun", "Earth’s tilted axis", "Moon’s gravity", "Solar flares"],
    correct: 1,
    explanation: "Seasons occur because Earth’s axis is tilted relative to its orbit around the Sun."
  },
  {
    id: 118,
    text: "What term describes the natural movement of water through soil and rocks into groundwater?",
    options: ["Condensation", "Runoff", "Infiltration", "Transpiration"],
    correct: 2,
    explanation: "Infiltration is when water seeps down from the surface into soil and porous rock layers."
  },
  {
    id: 119,
    text: "Which layer of Earth lies directly beneath the crust?",
    options: ["Outer core", "Inner core", "Mantle", "Lithosphere"],
    correct: 2,
    explanation: "The mantle lies below the crust and is composed of semi-solid rock that moves slowly."
  },
  {
    id: 120,
    text: "Which type of front forms when cold air moves under a retreating warm air mass?",
    options: ["Cold front", "Warm front", "Stationary front", "Occluded front"],
    correct: 0,
    explanation: "A warm front forms when warm air rises gradually over cooler air, bringing steady precipitation."
  },
  {
    id: 121,
    text: "What is the term for the continuous movement of water between Earth’s surface and the atmosphere?",
    options: ["Erosion cycle", "Water cycle", "Rock cycle", "Carbon cycle"],
    correct: 1,
    explanation: "The water cycle describes the continuous circulation of water through evaporation, condensation, and precipitation."
  },
  {
    id: 122,
    text: "What is the layer of gases surrounding Earth called?",
    options: ["Hydrosphere", "Lithosphere", "Atmosphere", "Biosphere"],
    correct: 2,
    explanation: "The atmosphere is the layer of gases surrounding Earth that supports life and climate."
  },
  {
    id: 123,
    text: "What kind of weather does a high-pressure system usually bring?",
    options: ["Stormy", "Windy", "Clear and calm", "Humid"],
    correct: 2,
    explanation: "High-pressure systems are associated with sinking air and generally bring clear, calm weather."
  },
  {
    id: 124,
    text: "Which planet is known for its prominent ring system?",
    options: ["Jupiter", "Uranus", "Neptune", "Saturn"],
    correct: 3,
    explanation: "Saturn is easily recognized for its large, bright ring system made of ice and rock particles."
  },
  {
    id: 125,
    text: "What kind of energy drives the Earth’s weather and climate systems?",
    options: ["Nuclear energy", "Geothermal energy", "Solar energy", "Chemical energy"],
    correct: 2,
    explanation: "The Sun’s solar energy powers atmospheric circulation and weather patterns on Earth."
  },
  {
    id: 126,
    text: "What layer of Earth lies directly below the crust?",
    options: ["Inner core", "Mantle", "Outer core", "Asthenosphere"],
    correct: 1,
    explanation: "The mantle lies beneath the crust and is composed of semi-solid rock that moves slowly over time."
  },
  {
    id: 127,
    text: "Which type of rock is formed from cooled lava that takes on a glass like appearance?",
    options: ["Igneous", "Sedimentary", "Metamorphic", "Obsidian"],
    correct: 3,
    explanation: "Obsidian is a type of metamorphic rock formed from cooled lava that takes on a glass-like appearance."
  },
  {
    id: 128,
    text: "What process in the water cycle involves water vapor turning into liquid?",
    options: ["Evaporation", "Condensation", "Precipitation", "Sublimation"],
    correct: 1,
    explanation: "Condensation is the process of water vapor cooling and turning back into liquid droplets."
  },
  {
    id: 129,
    text: "What natural phenomenon measures the shaking of the Earth’s surface?",
    options: ["Hurricane", "Tornado", "Earthquake", "Volcano"],
    correct: 2,
    explanation: "An earthquake is the result of sudden energy release in the Earth's crust, causing ground shaking."
  },
  {
    id: 130,
    text: "What type of boundary is formed when tectonic plates move away from each other?",
    options: ["Convergent boundary", "Divergent boundary", "Transform boundary", "Subduction zone"],
    correct: 3,
    explanation: "The subduction zone is a region of the Earth where one tectonic plate is diving beneath another into the interior of the Earth."
  },
  {
    id: 131,
    text: "What is the main gas responsible for the greenhouse effect on Earth?",
    options: ["Oxygen", "Carbon dioxide", "Nitrogen", "Hydrogen"],
    correct: 1,
    explanation: "Carbon dioxide traps heat in Earth’s atmosphere, contributing to the greenhouse effect."
  },
  {
    id: 132,
    text: "What scale is used to measure the magnitude of hurricanes?",
    options: ["Richter scale", "Beaufort scale", "Fujita scale", "Saffir-Simpson scale"],
    correct: 3,
    explanation: "The Richter scale measures the magnitude or energy released during an earthquake."
  },
  {
    id: 133,
    text: "What type of rock is formed when existing rock is changed by heat and pressure?",
    options: ["Sedimentary", "Igneous", "Metamorphic", "Basaltic"],
    correct: 2,
    explanation: "Metamorphic rocks form when existing rocks are altered by heat, pressure, or chemical processes."
  },
  {
    id: 134,
    text: "What is the Earth’s outermost layer called?",
    options: ["Crust", "Mantle", "Core", "Lithosphere"],
    correct: 0,
    explanation: "The crust is the thin, solid outermost layer of the Earth."
  },
  {
    id: 135,
    text: "Which layer of the atmosphere contains the enough breathable oxygen for human life?",
    options: ["Troposphere", "Stratosphere", "Mesosphere", "Thermosphere"],
    correct: 1,
    explanation: "The ozone layer, which absorbs harmful UV radiation and contains enough breathable oxygen, is located in the stratosphere."
  },
  {
    id: 136,
    text: "What is the process by which rocks are added to a landform to form a new landmass?",
    options: ["Erosion", "Weathering", "Sedimentation", "Deposition"],
    correct: 3,
    explanation: "Deposition in geology refers to the process where sediments, soil, and rocks are added to a landform or landmass, typically through the action of wind, water, or ice."
  },
  {
    id: 137,
    text: "Which ocean is the largest on Earth?",
    options: ["Atlantic Ocean", "Indian Ocean", "Pacific Ocean", "Arctic Ocean"],
    correct: 2,
    explanation: "The Pacific Ocean is the largest and deepest ocean on Earth."
  },
  {
    id: 138,
    text: "What causes ocean tides on Earth?",
    options: ["Wind", "Earth’s rotation", "Moon’s gravity", "Sun’s radiation"],
    correct: 2,
    explanation: "Tides are caused primarily by the gravitational pull of the Moon on Earth's oceans."
  },
  {
    id: 139,
    text: "Which planet is known as Earth’s twin because of its similar size and composition?",
    options: ["Mars", "Venus", "Mercury", "Jupiter"],
    correct: 1,
    explanation: "Venus is called Earth’s twin because it is similar in size, mass, and composition."
  },
  {
    id: 140,
    text: "What is the most common element in living creatures on Earth?",
    options: ["Oxygen", "Nitrogen", "Carbon", "Argon"],
    correct: 2,
    explanation: "Carbon is the most common element in living creatures on Earth."
  },
  {
    id: 141,
    text: "Which layer of Earth’s interior is solid, composed mostly of iron and nickel?",
    options: ["Inner core", "Outer core", "Mantle", "Crust"],
    correct: 0,
    explanation: "The inner core is a solid layer of metal, mainly composed of iron and nickel."
  },
  {
    id: 142,
    text: "What instrument is used to measure atmospheric pressure?",
    options: ["Barometer", "Thermometer", "Anemometer", "Hygrometer"],
    correct: 0,
    explanation: "A barometer measures atmospheric pressure and helps forecast weather changes."
  },
  {
    id: 143,
    text: "What is the name for molten rock beneath the Earth’s surface?",
    options: ["Lava", "Magma", "Basalt", "Sediment"],
    correct: 1,
    explanation: "Magma is molten rock beneath the surface, while lava is magma that reaches the surface."
  },
  {
    id: 144,
    text: "What do we call a scientist who studies the Earth's atmosphere and weather?",
    options: ["Meteorologist", "Geologist", "Astronomer", "Oceanographer"],
    correct: 0,
    explanation: "A meteorologist studies the atmosphere and predicts weather conditions."
  },
  {
    id: 145,
    text: "What kind of plate movement creates mountain ranges like the Himalayas?",
    options: ["Divergent", "Convergent", "Transform", "Subductive"],
    correct: 1,
    explanation: "Convergent plate movement, where plates collide, creates mountain ranges such as the Himalayas."
  },
  {
    id: 146,
    text: "What process describes the continuous movement of water on, above, and below Earth’s surface?",
    options: ["Carbon cycle", "Nitrogen cycle", "Water cycle", "Oxygen cycle"],
    correct: 2,
    explanation: "The water cycle describes the circulation of water through evaporation, condensation, and precipitation."
  },
  {
    id: 147,
    text: "Which natural disaster is measured using the Saffir-Simpson scale?",
    options: ["Earthquake", "Hurricane", "Tornado", "Flood"],
    correct: 1,
    explanation: "The Saffir-Simpson scale categorizes hurricanes based on wind speed and potential damage."
  },
  {
    id: 148,
    text: "What is the name for the point on Earth’s surface directly above an earthquake’s origin?",
    options: ["Epicenter", "Focus", "Crust", "Fault line"],
    correct: 0,
    explanation: "The epicenter is the point on the surface directly above where the earthquake originates."
  },
  {
    id: 149,
    text: "Which type of cloud is typically fluffy and white, indicating fair weather?",
    options: ["Stratus", "Cumulus", "Cirrus", "Nimbus"],
    correct: 1,
    explanation: "Cumulus clouds are puffy, white clouds that often signal fair weather."
  },
  {
    id: 150,
    text: "What do we call the narrow zone where freshwater meets saltwater?",
    options: ["Estuary", "Delta", "Lagoon", "Bay"],
    correct: 0,
    explanation: "An estuary is a coastal area where freshwater from rivers mixes with saltwater from the ocean."
  },
  {
    id: 151,
    text: "What is the layer of gases surrounding Earth called?",
    options: ["Lithosphere", "Hydrosphere", "Atmosphere", "Biosphere"],
    correct: 2,
    explanation: "The atmosphere is the envelope of gases that surrounds Earth and supports life."
  },
  {
    id: 152,
    text: "Which layer of the atmosphere is closest to Earth’s surface?",
    options: ["Stratosphere", "Mesosphere", "Thermosphere", "Troposphere"],
    correct: 3,
    explanation: "The troposphere is the lowest layer of the atmosphere where most weather occurs."
  },
  {
    id: 153,
    text: 'What is the "Great Red Spot" of Jupiter?',
    options: ["Storm", "Volcano", "Mountain", "Crater"],
    correct: 0,
    explanation: "The Great Red Spot on Jupiter is a large storm that rotates the planet."
  },
  {
    id: 154,
    text: "What process causes rocks to break apart without changing their chemical composition?",
    options: ["Chemical weathering", "Physical weathering", "Erosion", "Deposition"],
    correct: 1,
    explanation: "Physical weathering breaks rocks into smaller pieces through mechanical forces like freezing and thawing."
  },
  {
    id: 155,
    text: "Which type of volcano has gentle slopes and erupts basaltic lava flows?",
    options: ["Composite volcano", "Cinder cone", "Shield volcano", "Caldera"],
    correct: 2,
    explanation: "Shield volcanoes, like those in Hawaii, have gentle slopes formed by fluid lava flows."
  },
  {
    id: 156,
    text: "What is the name for a scientist who studies earthquakes?",
    options: ["Geologist", "Meteorologist", "Seismologist", "Volcanologist"],
    correct: 2,
    explanation: "A seismologist studies earthquakes and seismic waves that move through Earth."
  },
  {
    id: 157,
    text: "What is the process by which plants release water vapor into the atmosphere?",
    options: ["Transpiration", "Condensation", "Evaporation", "Sublimation"],
    correct: 0,
    explanation: "Transpiration occurs when plants release water vapor from their leaves into the atmosphere."
  },
  {
    id: 158,
    text: "What term describes molten rock that has erupted onto Earth’s surface?",
    options: ["Magma", "Lava", "Ash", "Basalt"],
    correct: 1,
    explanation: "Once magma reaches the surface, it is referred to as lava."
  },
  {
    id: 159,
    text: "What is the main energy source that drives the rock cycle?",
    options: ["Solar energy", "Nuclear decay", "Geothermal energy", "Magnetic energy"],
    correct: 2,
    explanation: "Geothermal energy from Earth’s interior powers melting and metamorphic processes in the rock cycle."
  },
  {
    id: 160,
    text: "What causes day and night on Earth?",
    options: ["Earth’s revolution around the Sun", "Earth’s rotation on its axis", "Sun’s rotation", "Moon’s orbit"],
    correct: 1,
    explanation: "Day and night occur because Earth rotates on its axis once every 24 hours."
  },
  {
    id: 161,
    text: "Which ocean current keeps Europe’s climate warmer than expected for its latitude?",
    options: ["Gulf Stream", "California Current", "Canary Current", "Kuroshio Current"],
    correct: 0,
    explanation: "The Gulf Stream carries warm water from the Gulf of Mexico toward Europe, moderating its climate."
  },
  {
    id: 162,
    text: "What type of boundary occurs when two tectonic plates slide past each other?",
    options: ["Divergent boundary", "Convergent boundary", "Transform boundary", "Subduction zone"],
    correct: 2,
    explanation: "At transform boundaries, plates slide horizontally past one another, causing earthquakes."
  },
  {
    id: 163,
    text: "What do we call the process by which sediments are moved from one place to another?",
    options: ["Weathering", "Deposition", "Erosion", "Compaction"],
    correct: 2,
    explanation: "Erosion is the process by which sediments are moved from one place to another."
  },
  {
    id: 164,
    text: "Which two layers of Earth’s interior together generate magnetic fields?",
    options: ["Mantle and Crust", "Inner Core and Outer Core", "Inner Core and Mantle", "Crust and Inner Core"],
    correct: 1,
    explanation: "The inner core is solid and made mostly of iron and nickel due to extreme pressure."
  },
  {
    id: 165,
    text: "What scale is used to measure the intensity of tornadoes?",
    options: ["Richter scale", "Enhanced Fujita scale", "Saffir-Simpson scale", "Mercalli scale"],
    correct: 1,
    explanation: "The Enhanced Fujita (EF) scale measures tornado intensity based on wind speed and damage."
  },
  {
    id: 166,
    text: "Which type of front forms when two air masses move slowly toward each other with neither adavancing or retreating?",
    options: ["Cold front", "Warm front", "Stationary front", "Occluded front"],
    correct: 2,
    explanation: "A stationary front is a weather front or transition zone between two air masses when each air mass is advancing into the other at speeds less than 5 knots at the ground surface."
  },
  {
    id: 167,
    text: "What is the primary cause of wind on Earth?",
    options: ["Earth’s rotation", "Temperature and pressure differences", "Gravitational pull", "Ocean tides"],
    correct: 1,
    explanation: "Wind is caused by air moving from areas of high pressure to areas of low pressure due to temperature differences."
  },
  {
    id: 168,
    text: "What type of cloud often brings steady rain or drizzle?",
    options: ["Cumulus", "Cirrus", "Stratus", "Nimbus"],
    correct: 2,
    explanation: "Stratus clouds are low, gray clouds that typically bring light rain or drizzle."
  },
  {
    id: 169,
    text: "What is the boundary between two air masses called?",
    options: ["Front", "Jet stream", "Trough", "Cyclone"],
    correct: 0,
    explanation: "A front is a boundary between two air masses of different temperatures and humidity levels."
  },
  {
    id: 170,
    text: "What is the term for a large, nearly circular depression formed after a volcanic eruption?",
    options: ["Crater", "Caldera", "Vent", "Fissure"],
    correct: 1,
    explanation: "A caldera forms when a volcano collapses after expelling large amounts of magma."
  },
  {
    id: 171,
    text: "What natural process helps recycle carbon through Earth’s systems?",
    options: ["Nitrogen cycle", "Carbon cycle", "Water cycle", "Oxygen cycle"],
    correct: 1,
    explanation: "The carbon cycle moves carbon between the atmosphere, oceans, soil, and living organisms."
  },
  {
    id: 172,
    text: "Which planet in the solar system has the most extreme temperature variations?",
    options: ["Mercury", "Venus", "Mars", "Neptune"],
    correct: 0,
    explanation: "Mercury experiences huge temperature changes due to its lack of atmosphere and proximity to the Sun."
  },
  {
    id: 173,
    text: "What type of rock forms when lava cools quickly on Earth’s surface?",
    options: ["Metamorphic", "Sedimentary", "Extrusive igneous", "Intrusive igneous"],
    correct: 2,
    explanation: "Extrusive igneous rocks form from lava that cools rapidly on the surface, such as basalt."
  },
  {
    id: 174,
    text: "What do we call a narrow funnel-shaped cloud that touches both the cloud base and the ground?",
    options: ["Cyclone", "Tornado", "Hurricane", "Waterspout"],
    correct: 1,
    explanation: "A tornado is a violently rotating column of air extending from a thunderstorm to the ground."
  },
  {
    id: 175,
    text: "What type of ecosystem forms where a river meets the sea and supports diverse life?",
    options: ["Coral reef", "Wetland", "Estuary", "Mangrove forest"],
    correct: 2,
    explanation: "An estuary forms where freshwater meets saltwater, providing a rich habitat for many species."
  },
  {
    id: 176,
    text: "Which gas is most responsible for trapping heat in Earth’s atmosphere?",
    options: ["Carbon monoxide", "Carbon dioxide", "Nitrogen dioxide", "Hydrogen peroxide"],
    correct: 1,
    explanation: "Carbon dioxide is a greenhouse gas that traps heat and contributes to the warming of Earth’s atmosphere."
  },
  {
    id: 177,
    text: "Which kind of sting are clownfish adapted to resist, allowing them to live among these animals??",
    options: ["Ray stings", "Bee stings", "Anemone stings", "Jellyfish stings"],
    correct: 2,
    explanation: " Clownfish are protected from their host anemone’s stings due to a special mucus coat, but not generally immune to other types of stings."
  },
  {
    id: 178,
    text: "What happens to the temperature of a rubber when it is stretched?",
    options: ["Melts", "Freezes", "Increases", "Decreases"],
    correct: 2,
    explanation: "When a rubber is stretched, the temperature of the rubber increases."
  },
  {
    id: 179,
    text: "What process turns liquid water into water vapor?",
    options: ["Condensation", "Evaporation", "Precipitation", "Sublimation"],
    correct: 1,
    explanation: "Evaporation occurs when liquid water gains enough energy to change into vapor."
  },
  {
    id: 180,
    text: "What is the approximate percentage of nitrogen in Earth’s atmosphere?",
    options: ["21%", "50%", "78%", "84%"],
    correct: 2,
    explanation: "Nitrogen makes up about 78% of Earth’s atmosphere, with oxygen being around 21%."
  },
  {
    id: 181,
    text: "Which layer of Earth’s atmosphere contains the ozone layer?",
    options: ["Troposphere", "Stratosphere", "Mesosphere", "Thermosphere"],
    correct: 1,
    explanation: "The ozone layer, which absorbs harmful UV radiation, is located in the stratosphere."
  },
  {
    id: 182,
    text: "What is the primary source of Earth’s magnetic field?",
    options: ["The Moon’s gravity", "Solar winds", "Earth’s iron core", "Tectonic activity"],
    correct: 2,
    explanation: "Earth’s magnetic field is generated by the motion of molten iron in the outer core."
  },
  {
    id: 183,
    text: "Which planet has a day longer than its year?",
    options: ["Mercury", "Venus", "Mars", "Pluto"],
    correct: 1,
    explanation: "Venus rotates so slowly that one rotation (a day) takes longer than one revolution around the Sun (a year)."
  },
  {
    id: 184,
    text: "What is the main component of the Sun?",
    options: ["Oxygen", "Hydrogen", "Carbon Dioxide", "Helium"],
    correct: 1,
    explanation: "Hydrogen makes up about 74% of the Sun’s mass, with helium as the second most abundant element."
  },
  {
    id: 185,
    text: "What term describes the movement of continents over geological time?",
    options: ["Plate tectonics", "Continental drift", "Subduction", "Seafloor spreading"],
    correct: 1,
    explanation: "Continental drift describes the gradual movement of continents across Earth’s surface over time."
  },
  {
    id: 186,
    text: "What type of energy transformation occurs in a hydroelectric dam?",
    options: ["Thermal to electrical", "Nuclear to electrical", "Chemical to electrical", "Kinetic to electrical"],
    correct: 3,
    explanation: "A hydroelectric dam converts the kinetic energy of moving water into electrical energy."
  },
  {
    id: 187,
    text: "Which planet is known as the 'Red Planet' due to iron oxide on its surface?",
    options: ["Venus", "Mars", "Mercury", "Jupiter"],
    correct: 1,
    explanation: "Mars appears red because its surface is covered with iron oxide (rust)."
  },
  {
    id: 188,
    text: "What is the unit used to measure electrical current?",
    options: ["Volt", "Watt", "Ampere", "Ohm"],
    correct: 2,
    explanation: "Electrical current is measured in amperes (amps)."
  },
  {
    id: 189,
    text: "What natural phenomenon causes the Northern and Southern Lights?",
    options: ["Volcanic eruptions", "Solar wind interacting with Earth’s magnetic field", "Lightning storms", "Meteor showers"],
    correct: 1,
    explanation: "Auroras are caused by charged particles from the solar wind interacting with Earth’s magnetic field."
  },
  {
    id: 190,
    text: "Which part of a plant is responsible for photosynthesis?",
    options: ["Roots", "Stems", "Leaves", "Flowers"],
    correct: 2,
    explanation: "Photosynthesis occurs in the chloroplasts within plant leaves."
  },
  {
    id: 191,
    text: "What type of energy does a moving object have?",
    options: ["Potential energy", "Kinetic energy", "Chemical energy", "Elastic energy"],
    correct: 1,
    explanation: "Kinetic energy is the energy of motion possessed by moving objects."
  },
  {
    id: 192,
    text: "What kind of weather front usually brings thunderstorms?",
    options: ["Cold front", "Warm front", "Stationary front", "Occluded front"],
    correct: 0,
    explanation: "Cold fronts often bring thunderstorms as cold air rapidly forces warm air upward."
  },
  {
    id: 193,
    text: "Which planet rotates on its side, making its seasons extremely unusual?",
    options: ["Neptune", "Uranus", "Jupiter", "Saturn"],
    correct: 1,
    explanation: "Uranus rotates on its side with an axial tilt of about 98°, giving it extreme seasonal changes."
  },
  {
    id: 194,
    text: "What kind of simple machine is a seesaw?",
    options: ["Pulley", "Lever", "Wheel and axle", "Inclined plane"],
    correct: 1,
    explanation: "A seesaw is an example of a lever, which rotates around a fixed point called a fulcrum."
  },
  {
    id: 195,
    text: "What causes the apparent color change of objects when submerged in water?",
    options: ["Reflection", "Absorption", "Diffusion", "Refraction"],
    correct: 3,
    explanation: "Refraction bends light as it passes through water, altering how colors appear to our eyes."
  },
  {
    id: 196,
    text: "What part of the atom contains protons and neutrons?",
    options: ["Electron cloud", "Nucleus", "Shell", "Core"],
    correct: 1,
    explanation: "The nucleus is the dense center of an atom containing protons and neutrons."
  },
  {
    id: 197,
    text: "Which planet has the most moons?",
    options: ["Jupiter", "Saturn", "Uranus", "Neptune"],
    correct: 1,
    explanation: "As of current data, Saturn has the most confirmed moons of any planet in the solar system."
  },
  {
    id: 198,
    text: "What kind of heat transfer occurs through direct contact between materials?",
    options: ["Conduction", "Convection", "Radiation", "Evaporation"],
    correct: 0,
    explanation: "Conduction transfers heat through direct contact between substances."
  },
  {
    id: 199,
    text: "What is the name of the process by which plants convert sunlight into chemical energy?",
    options: ["Respiration", "Photosynthesis", "Fermentation", "Transpiration"],
    correct: 1,
    explanation: "Photosynthesis allows plants to convert sunlight, carbon dioxide, and water into glucose and oxygen."
  },
  {
    id: 200,
    text: "Which layer of Earth’s atmosphere is responsible for absorbing most of the Sun’s ultraviolet radiation?",
    options: ["Troposphere", "Stratosphere", "Mesosphere", "Thermosphere"],
    correct: 1,
    explanation: "The ozone layer, located in the stratosphere, absorbs most of the Sun’s harmful UV rays."
  },
];

export const PHYSICAL_SCIENCE_CONFIG = {
  timeLimit: 10 * 60,
  sectionName: "Physical Science",
  totalQuestions: 20
};